import { render, staticRenderFns } from "./InterventionLevels.vue?vue&type=template&id=f60ec13a&scoped=true"
import script from "./InterventionLevels.vue?vue&type=script&lang=js"
export * from "./InterventionLevels.vue?vue&type=script&lang=js"
import style0 from "./InterventionLevels.vue?vue&type=style&index=0&id=f60ec13a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60ec13a",
  null
  
)

export default component.exports